<template>
  <div class="nav">
    <div class="nav-cur" @click="setCur(0)"><i class="el-icon-menu"></i> 2023年经营管理目录
      <transition name="el-zoom-in-bottom">
        <div class="sub-mune transition-box" v-if="subMune">
          <div @click="setLink(0)">年度公司经营数据</div>
          <div @click="setLink(1)">年度BU经营数据</div>
          <div @click="setLink(2)">费用检测</div>
          <div @click="setLink(3)">市场经营数据</div>
          <div @click="setLink(4)">市场呼叫内部支持</div>
          <div @click="setLink(5)">产品实用化与质量稳定性调查（内部）</div>
          <div @click="setLink(6)">产品实用化与质量稳定性评价（外部）</div>
          <div @click="setLink(7)">新产品现场稳定运行评价</div>
          <div @click="setLink(8)">产品影响力提升</div>
          <div @click="setLink(9)">生产单台综合成品</div>
          <div @click="setLink(10)">交付及时率</div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NavStyleYear',
    data() {
      return {
        subMune: false,
        baseLink: '/year',
        linkPathArr: ['/year01', '/year02', '/year03', '/year04', '/year05', '/year06', '/year07', '/year08', '/year09', '/year10', '/year11'],
        status: false
      }
    },
    methods: {
      setCur(key, path) {
        this.subMune = !this.subMune
      },
      setLink(key) {
        this.$router.push({
          path: this.baseLink + this.linkPathArr[key]
        })
      }
    }
  }
</script>

<style>
  .nav {
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    z-index: 9999;
  }

  .nav>div {
    width: 100%;
    text-align: center;
    line-height: 3.6rem;
    background-color: #fafafa;
    box-sizing: border-box;
    color: #646464;
    border-right: 1px solid #e5e5e5;
    position: relative;
  }

  .nav>div:last-child {
    border-right: none;
  }

  .nav>div.nav-cur {
    background-color: #24dadd;
    color: white;
  }

  .sub-mune {
    position: absolute;
    bottom: 3.6rem;
    right: 0;
    width: 100%;
    line-height: 3rem;
    background-color: white;
  }

  .sub-mune>div {
    border-bottom: 1px solid #e5e5e5;
    color: #646464;
  }

  .sub-mune>div:hover {
    background-color: #f5f5f5;
    color: #323232;
  }
</style>
